import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJusteatComponent } from './simple-icons-justeat.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJusteatComponent ],
    exports:      [ SimpleIconsJusteatComponent ],
    bootstrap:    []
})
export class SimpleIconsJusteatModule {}
